/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Team_Add_DescriptionInputs */



/**
* | output |
* | --- |
* | "Add teams to share this space with multiple users at once" |
*
* @param {Spaces_Team_Add_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_team_add_description = /** @type {((inputs?: Spaces_Team_Add_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Team_Add_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge Teams hinzu, um diesen Space mit mehreren Benutzern gleichzeitig zu teilen")
	return /** @type {LocalizedString} */ ("Add teams to share this space with multiple users at once")
});